import { TokenServiceClient } from '@johnlewispartnership/wtr-website-authentication/dist/service';
import config from 'config';
import getApiBaseUrl from 'utils/getApiBaseUrl';

// Todo: figure out how we could do logging for any ServiceClient out-of-the-box
const tokenServiceClient = new TokenServiceClient(getApiBaseUrl(config.services.tokenClient.path));
export default tokenServiceClient;
